import config from 'config';
import React, { Fragment } from 'react';

import { ArchivedAppointmentsFilter, ArchivedAppointmentsList } from 'modules/queues/Archive/containers';

const AppointmentsSidebar = () => (
  <Fragment>
    {/*<If condition={ config.product_name !== 'clalit' } >*/}
      <ArchivedAppointmentsFilter />
    {/*</If>*/}
    <ArchivedAppointmentsList />
  </Fragment>
);

export default AppointmentsSidebar;
